var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3V13.5L19.95 15.45C19.98 15.3 20 15.15 20 15V3C20 1.9 19.1 1 18 1H5.5L7.5 3H18Z",
    fill: "#3E72DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21995 0.319946L0.949951 1.58995L1.99995 2.63995V14.9999C1.99995 16.0999 2.89995 16.9999 3.99995 16.9999H16.36L18.42 19.0599L19.69 17.7899L2.21995 0.319946ZM3.99995 14.9999V4.63995L14.36 14.9999H3.99995Z",
    fill: "#3E72DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFile);
export default __webpack_public_path__ + "static/media/NoFile.9bc470c5e0e98d592d8b3ac1aadb0c1b.svg";
export { ForwardRef as ReactComponent };